// extracted by mini-css-extract-plugin
export default {"sbtH5":"SbtH5_sbtH5__qFhkr"};